<template>
  <v-btn
    color="primary"
    :small="small"
    :to="to"
    class="text-none font-weight-bold"
    @click="$emit('click')"
    :max-width="maxWidth"
    :min-width="minWidth"
    :width="width"
    :text="text"
    :loading="loading"
    rounded
    :outlined="outlined"
    :block="block"
  >
    <slot />
  </v-btn>
</template>

<script>
export default {
  props: {
    outlined: Boolean,
    block: Boolean,
    small: Boolean,
    loading:Boolean,
    text: Boolean,
    to: String,
    maxWidth: [String, Number],
    minWidth: [String, Number],
    width: [String, Number]
  },

};
</script>
